<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Vehicles" title="View Vehicles" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">

					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row align-items-center">
									<div class="col-md-4 d-flex align-items-center">
										<label class="d-flex listing-length ms-1 align-items-center">
											<span class="me-2">Show</span>
											<select class="form-select w-auto" v-model="listing_length" @change="fetchVehicles()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span class="ms-2">entries</span>
										</label>
									</div>

									<div class="col-md-8 text-end">
										<input type="text" class="form-control d-inline-block w-25" placeholder="Search" v-model="keyword" @keyup="fetchVehicles()"/>
									</div>
								</div>
							</div>
		
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
											<th>Vehicle No.</th>
											<th>IMEI</th>
											<th>Chasis No.</th>
											<th>Engine No.</th>
											<th>Brand & Model</th>
											<th>Company</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody v-if="Boolean(vehicles.length)">
										<tr align="center" v-for="(vehicle,index) in vehicles" :key="vehicle.id">
                                            <td>{{vehicle.vehicle_number}}</td>
											<td>{{vehicle.imei}}</td>
											<td>{{vehicle.chassis_number}}</td>
                                            <td>{{vehicle.engine_number}}</td>
                                            <td>{{vehicle.vehicle_make}}<br>
												{{vehicle.vehicle_model}}
											</td>
                                            <td>{{vehicle.company_name}}</td>
                                            <td>
												<router-link :to="{ name: 'edit_vehicle',params:{id:vehicle.id} }" class="btn btn-primary btn-sm me-2 mt-1">Edit</router-link>
                                            </td>
                                        </tr>	
									</tbody>

									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>

									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(vehicles.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchVehicles(page.url + '&keyword=' + keyword  +  '&limit=' + listing_length)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<!-- <label class="control-label">Logo </label> -->
							<input class="form-control" type="file" accept=".xls, .xlsx" />
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	  
   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Coupons eport",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				vehicles: [],
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,				

				modal_title: "Upload Excel",
				button_title: "Upload",

			};
		},
		mounted() {},

		created() {
			this.fetchVehicles();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchVehicles(page_url = null) {
				this.getToken();
				let url = "/staffs/vehicles?limit=" + this.listing_length  +  "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.vehicles = responseData.vehicles.data;
						this.pagination = responseData.vehicles.links;
						this.from = responseData.vehicles.from;
						this.to = responseData.vehicles.to;
						this.total = responseData.vehicles.total;
						
					})
					.catch((err) => console.log(err));
			},


			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},
            
			clearForm() {
				this.edit = false;
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

		},
	};
</script>
